import { useMemo, useState } from 'react';
import { DEFAULT_SEARCH } from '../constants/efax-search-defaults';
import type { EfaxSearchState } from '../types';
import { isSameEfaxSearch } from '../utils/efax-search-utils';

export const useEfaxSearch = () => {
  const [search, setSearch] = useState<EfaxSearchState>(DEFAULT_SEARCH);
  const [appliedSearch, setAppliedSearch] =
    useState<EfaxSearchState>(DEFAULT_SEARCH);
  const [hasSearched, setHasSearched] = useState(false);

  const hasUnappliedChanges = useMemo(
    () => hasSearched && !isSameEfaxSearch(appliedSearch, search),
    [search, appliedSearch, hasSearched],
  );

  const onSearch = () => {
    setAppliedSearch(search);
    setHasSearched(true);
  };

  const onClear = () => {
    setSearch(DEFAULT_SEARCH);
    setAppliedSearch(DEFAULT_SEARCH);
    setHasSearched(false);
  };

  return {
    search,
    setSearch,
    appliedSearch,
    hasSearched,
    hasUnappliedChanges,
    onSearch,
    onClear,
  };
};
